export default "__VITE_ASSET__B3U9NsvL__"